import {Row, Col, Spin, Alert} from 'antd';
import * as React from 'react';
import { resolve } from 'inversify-react';

import { ObjectUtils } from 'src/core/utils/object';
import {ImageGalleryController} from 'src/app/products/image-gallery/image-gallery.controller'
import {TaxonomyTagsRenderer} from './search-results-taxonomy.view'
import { EntitySchemaDataService } from 'src/app/general/entity-schemas/entity-schema.data';

import { ToastNotifications } from 'src/core/ui/toast';



interface RoomSummaryViewProps {
	product?: ProductItem;
	setBusy: (isBusy: boolean)=>any;
	horizontal?: boolean;
	textWidth: number;
	picturesWidth: number;
	externalPadding: number;
	internalPadding: number;
	colSpan: number;
}
interface RoomSummaryViewState{
	schema: JsonSchema;
}

interface IExtendedProperty {
	name: string;
	label: string;
	model: any;
	onChange: (value: any) => void;
	required: boolean;
	schema: JsonSchema;
}

export class RoomSummaryView extends React.Component<RoomSummaryViewProps, RoomSummaryViewState> {
	@resolve
	private toast: ToastNotifications;

	constructor(props: Readonly<RoomSummaryViewProps>) {
		super(props);

		this.state = {
			schema: null,
		};
	}

	componentDidMount() {
		this.loadSchema();
	}

	private async loadSchema(): Promise<void> {
		const entitySchemaService = EntitySchemaDataService.make();

		entitySchemaService.addFilter('name', 'eq', 'Product');
		entitySchemaService.addSorting('name', 'asc', true);
		entitySchemaService.pageSize = 1;

		this.props.setBusy(true);
		try{
			await entitySchemaService.load(query => query);
		}
		catch(er){
			this.toast.showToast('Error!', ObjectUtils.parseError(er), 'error');
		}
		finally{
			this.props.setBusy(false);
		}
		const entitySchema =  entitySchemaService.item;
		const schema = ObjectUtils.toObject<JsonSchema>(entitySchema.schema);
		this.setState({ schema: schema });
	}


	private isTaxonomy(schema: JsonSchema): boolean {
		return schema.$ref != null || (schema.items != null && schema.items.$ref != null);
	}

	private getExtendedProperties(model: any, schema: JsonSchema): IExtendedProperty[] {
		const { properties, required } = schema.allOf[0];

		return Object.keys(properties)
			.map((propertyName) => {
				const jsc = properties[propertyName] as JsonSchema;
				return {
					name: propertyName,
					label: jsc.title,
					model: model[propertyName],
					onChange: (value: any) => model[propertyName] = value,
					required: required.some((p) => p === propertyName),
					schema: jsc
				};
			});
	}
	private getTaxonomyRef(schema: JsonSchema): string{
		let taxonomy: string;
		if (schema.$ref != null) {
			taxonomy = schema.$ref;
		} else {
			taxonomy = schema.items.$ref;
		}

		return taxonomy;
	}

	render(){
		const {product, setBusy, horizontal , picturesWidth, textWidth, externalPadding, internalPadding, colSpan}=this.props;
		const {schema}=this.state;


		if(product && schema){
			const validTaxonomies=product.category.taxonomicFields;
			const model=product.dynamicProperties;

			let properties = this.getExtendedProperties(model, schema);
			if (validTaxonomies != null) {
				properties = properties.filter(m => this.isTaxonomy(m.schema) && validTaxonomies.some(p => p === m.name));
			}

			let anyTaxonomy=false;
			const taxonomiesRefs=properties.map((m)=>[this.getTaxonomyRef(m.schema), m.name]);
			const taxonomiesViews=taxonomiesRefs.map((taxonomy)=>{
				const taxName=taxonomy[0];
				const propName=taxonomy[1];
				anyTaxonomy=anyTaxonomy||model[propName];
				return <TaxonomyTagsRenderer key={taxName}  model={model} propName={propName} taxonomyDefinitionName={taxName} colSpan={colSpan} vertical={true} setBusy={setBusy}/>
			});

			if (product == null) {
				return (
					<Spin spinning={true} size="large">
						<Alert
							message="LOADING"
							description="Please wait to loading product info."
							type="info"
							/>
					</Spin>
				);
			}

			let description=(
				<div style={{fontWeight:"bold"}}>
					No description for this product
				</div>
			);
			if(product.dynamicProperties.translations.en)
				description=(
					<div style={{width: textWidth}}>
						<p>{product.dynamicProperties.translations.en}</p>
					</div>
				)

			let taxonomies: any=(
				<div style={{fontWeight:"bold"}}>
					No features to display
				</div>
			)
			if(taxonomiesViews.length>0 && anyTaxonomy)
				taxonomies=taxonomiesViews;

			const verticalDisplay=(<div style={{padding: externalPadding}}>
				<Row style={{padding: internalPadding}} type="flex" justify="center" >
					<Row>
						<div style={{width: picturesWidth}}>
							<ImageGalleryController
								mode={"display"}
								model={product.documentsLibraryId}
								setBusy={setBusy}
								hideEdit={true}
								/>
						</div>
					</Row>


					<Row>
						{description}
					</Row>
				</Row>
				<Row  style={{padding: internalPadding}}>
					{taxonomies}
				</Row>
			</div>
			);

			const horizontalDisplay=(<div style={{padding: externalPadding}}>
				<Row style={{padding: internalPadding}} type="flex" justify="space-between" >
					<Col>
						<Row>
							{description}
						</Row>

						<Row  style={{padding: internalPadding}}>
							{taxonomies}
						</Row>
					</Col>
					<Col>
						<Row>
							<div style={{width: picturesWidth}}>
								<ImageGalleryController
									mode={"display"}
									model={product.documentsLibraryId}
									setBusy={setBusy}
									hideEdit={true}
									/>
							</div>
						</Row>
					</Col>
				</Row>
			</div>
			);


			return horizontal? (horizontalDisplay) : (verticalDisplay);
		}
		else{
			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-results-room-summary.view.tsx